import axios from 'axios';
const apicheckout = axios.create({baseURL: "https://evconnect.farmaciaevidence.com.br/api/v1"})
export default apicheckout;